import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { translate, formatData, getUserNameToName } from '../../../../../utils/util';
import { Row, Modal } from 'react-materialize';
import ButtonUI from '../../../../../components/UI/ButtonUI';
import RouteDeliveryService from '../../../../../services/RouteDeliveryService';
import useComponentVisible from '../../../../../utils/clickOutSideHooks';

const DeliveryRouteLocationTargetListItem = (props) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    const onConfirm = (routeLocationTarget) => {
        props.deleteRouteLocationTarget(routeLocationTarget, () => {
            if (props.refreshComponent) {
                props.refreshComponent();
            }
        });
    };

    const GetStringPdus = (locationTargets) => {
        let aux = "";
        locationTargets.forEach(x => {
            aux += `${x.locationTarget}; `;
        });

        return aux.slice(0, aux.length - 2);
    };

    return (
        <>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', right: '15px', zIndex: '999' }}
                ref={ref}
            >
                <Modal
                    open={isComponentVisible}
                    options={{ dismissible: false }}
                    id={`modal-id-${props.data.id}`}
                    fixedFooter
                    style={{ marginTop: "15px", maxHeight: "60%" }}
                    actions={
                        <Row className="center" style={{ height: "60%" }}>
                            <ButtonUI secundary='true' text={translate('cancel', 'general')} />
                            <ButtonUI onClick={() => onConfirm(props.data)} text={translate('delete', 'general')} />
                        </Row>
                    }
                >
                    <div>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="col s12">
                                    <i className="material-icons large">info_outline</i>
                                </span>
                                <span className="title col s12">{translate('messages.confirmation-delete', 'route-delivery')}</span>
                            </div>
                        </Row>
                    </div>
                </Modal>
                <i className="material-icons small sixth-text-color" onClick={() => setIsComponentVisible(true)} style={{ cursor: 'pointer' }}>delete</i>
            </span>
            <Link
                style={{ display: 'block' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color">
                    <i className="mdi mdi-account" /> {props.data.routeCode}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-map-marker-path" /> {GetStringPdus(props.data.locationTargets)}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-account" /> {getUserNameToName(props.usersFromElog, props.data.lastUpdatedBy)}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-history" /> {formatData(props.data?.lastUpdatedOn)}
                </span>
            </Link>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        locationtarget: state.deliveryReducer.locationTarget,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteRouteLocationTarget: (routeLocationTarget, callback) => {
            dispatch(RouteDeliveryService.deleteRouteLocationTarget(routeLocationTarget.routeId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeliveryRouteLocationTargetListItem)));
